export default "__VITE_ASSET__VIEAjBhS__"